import {classes, property_of} from '@bitstillery/common/lib/utils'
import {unique_id} from '@bitstillery/common/lib/utils'
import {is_signal} from '@bitstillery/common/lib/store'
import {MithrilComponent} from '@bitstillery/mithril'
import {$t} from '@bitstillery/common/app'
import m, {type Signal} from '@bitstillery/mithril'

import type {FilterI18nResolved} from '@bitstillery/common/types/filters'

interface RadioGroupAttrs {
    className?: string
    label?: string
    disabled?: boolean | undefined
    translate?: FilterI18nResolved | undefined
    help?: string | (() => string)
    /** Clicking the checked option runs this instead of re-selecting it; without it that click is a no-op. */
    ondeselect?: () => void
    options: ([string | number | boolean, string, number?] | string[])[]
    model?: [object | null | undefined, string] | Signal<unknown> | undefined
}

export class RadioGroup extends MithrilComponent<RadioGroupAttrs> {
    name = unique_id()

    model_value(attrs: RadioGroupAttrs) {
        const {model} = attrs
        if (!model) {
            return
        }
        if (is_signal(model)) {
            return model.value
        }
        return property_of(model[0], model[1])
    }

    model_assign(attrs: RadioGroupAttrs, value: unknown) {
        const {model} = attrs
        if (!model) {
            return
        }
        if (is_signal(model)) {
            model.value = value
            return
        }
        if (model[0]) {
            Reflect.set(model[0], model[1], value)
        }
    }

    view(vn: m.Vnode<RadioGroupAttrs>) {
        return (
            <div className={classes('c-radio-group', 'field', vn.attrs.className)}>
                {vn.attrs.label && <label>{vn.attrs.label}</label>}
                {vn.attrs.options.map((option) => (
                    <div className={classes('item', {disabled: option.length >= 3 && option[2] === 0})}>
                        <input
                            autocomplete='off'
                            checked={option[0] === this.model_value(vn.attrs) ? 'checked' : ''}
                            disabled={vn.attrs.disabled}
                            onclick={() => {
                                if (vn.attrs.ondeselect && option[0] === this.model_value(vn.attrs)) {
                                    vn.attrs.ondeselect()
                                    return
                                }
                                this.model_assign(vn.attrs, option[0])
                            }}
                            type='radio'
                            id={`${this.name}-${option[0]}`}
                            name={`${this.name}-${option[0]}`}
                        />
                        <label for={`${this.name}-${option[0]}`}>
                            {(() => {
                                if (!vn.attrs.translate) {
                                    return option[1]
                                }
                                return $t(`${vn.attrs.translate.prefix}${option[1]}`)
                            })()}
                        </label>
                        {option.length >= 3 && <div className='count'>{option[2]}</div>}
                    </div>
                ))}
                {vn.attrs.help && <div class='help'>{typeof vn.attrs.help === 'function' ? vn.attrs.help() : vn.attrs.help}</div>}
            </div>
        )
    }
}
